import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { CardStatusType, CardType, baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Subject, takeUntil, tap } from 'rxjs';
import { CardState } from '../../../../lib/state/card.state';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-lost-stolen',
  templateUrl: './lost-stolen.component.html',
  styleUrls: ['./lost-stolen.component.scss'],
})
export class LostStolenComponent implements OnInit {
  @AutoDestroy destroy$ = new Subject<void>();
  @Input() isSeparateZone: boolean;
  @Input() isWorkflow: boolean;
  @Input() borderStyle: baseCssConfigStyle;
  @Input() textContentStyle: baseCssConfigStyle;
  @Input() contentStyle: baseCssConfigStyle;
  @Output() openPopupEvent = new EventEmitter();

  isWidgetEnabled: boolean;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store
      .select(CardState.getCurrentCardDetail)
      .pipe(
        takeUntil(this.destroy$),
        tap((response) => {
          if (response) {
            this.isWidgetEnabled =
              response?.type !== CardType.VIRTUAL && response.status === CardStatusType.ACTIVE;
          }
        }),
      )
      .subscribe();
  }

  opeLostCardPopup() {
    this.openPopupEvent.emit(true);
  }
}
